import config from 'config';
import urlParse from 'url-parse';
import cookie from 'js-cookie';

export default function fetchWithAuth(url, options = {}) {
  const { hostname } = urlParse(config.API_ENV || window.location.href);
  const subdomain = hostname.split('.')[0];
  const jwt = cookie.get(`auth_token_${subdomain}`) || cookie.get('auth_token');

  return fetch(`${config.API_ENV}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${jwt}`,
    },
  });
}
